import { ErrorBanner } from './MutliProFormaReviewComponents.RightPane.ErrorBanner';
import { FooterErrorBanner } from './MutliProFormaReviewComponents.RightPane.FooterErrorBanner';
import { Footer } from './MultiProFormaReviewComponents.Footer';
import { Content } from './MutliProFormaReviewComponents.RightPane.Content';
import { ConfirmationModal } from './MultiProFormaReviewComponents.ConfirmationModal';

export const MultiProFormaReviewComponents = {
  RightPane: {
    Content,
    ErrorBanner,
    FooterErrorBanner,
  },
  Footer,
  ConfirmationModal,
};
